import axios from "axios";
import { Enviroment } from "../../../enviroments";
import CookieService from "../../autenticacao/CookieService";
import { errorInterceptor } from "./interceptor.ts";
import { responseInterceptor } from "./interceptor.ts/ResponseInterceptor";


const Api = axios.create({
    
    baseURL: Enviroment.URL_BASE,
    //      timeout: 30000     
    headers: {
        
        "Access-Control-Allow-Origin": "*",
        chavesessao: CookieService.get("access_token")
            
    }
});

Api.interceptors.response.use(
    (response) => responseInterceptor(response),
    (error) => errorInterceptor(error)
);

export { Api };